import {WBCommonException, ServerException, SystemException, UnavailableException} from './entity';

export class ExceptionFactory {

    public static createServerException(status: number, message: string, code?: string): WBCommonException {
        return new ServerException(status, message, code);
    }

    public static createSystemException(message: string, error: any): WBCommonException {
        return new SystemException(message, error);
    }

    public static createUnavailableException(message: string, description?: string): WBCommonException {
        return new UnavailableException(message, description);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/exception/exception.factory.ts